import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { WebService } from "../../Services/WebService";
import { Form, FormInputText, FormInputDropdown } from "../Form";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import SweetAlert from "sweetalert2";
import { WSInfoAlert } from "../../Services/WSAlert";

const { forwardRef, useState, useImperativeHandle } = React;
const AddEditARTypeMaster = (prop, ref) => {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [data, setData] = useState({ ARType: {} });
  useImperativeHandle(ref, () => ({
    openModal: async (id) => {
      const data = await WebService({
        endPoint: `ARTypeMaster/Fetch/${id || 0}`,
        dispatch,
      });
      // data.Company = data.Company.map((v) => {
      //   return {
      //     value: v.id,
      //     text: v.name,
      //   };
      // });

      data.SalaryComponent = data.SalaryComponent.map((v) => {
        return {
          value: v.SalaryComponentsId,
          text: v.EarningOrDeductionName,
        };
      });
      setData(data);
      setShow(true);
    },
  }));
  const handleClose = () => setShow(false);
  const requiredMessage = "This is a required field";
  const schema = yup
    .object()
    .shape({
      SalaryComponentId: yup.string().trim().required(requiredMessage),
      Code: yup.string().trim().required(requiredMessage),
    })
    .required();

  const onSubmit = async (data) => {
    //alert(JSON.stringify(data));
    const responsedata = await WebService({
      endPoint: "ARTypeMaster/Submit",
      body: data,
      dispatch,
    });
    WSInfoAlert("Info", responsedata);
    handleClose();
    prop.callBackEvent();
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          {(data.ARType.ARTypeId || 0) === 0 ? "Add AR Type" : "Edit AR Type"}
        </Modal.Title>
      </Modal.Header>
      <Form
        defaultValues={data.ARType}
        onSubmit={onSubmit}
        validationSchema={schema}
      >
        <Modal.Body className="p-4">
          <div className="row mt-1">
            <FormInputDropdown
              name="SalaryComponentId"
              ddOpt={data.SalaryComponent}
              label="Salary Component"
              isRequired="true"
            ></FormInputDropdown>
          </div>
          <div className="row mt-1">
            <FormInputText
              name="Code"
              isRequired="true"
              label="Code"
              type="text"
            />
          </div>
          <div className="row mt-1">
            <FormInputText
              label="Display Description"
              name="DisplayDescription"
              type="text"
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button id="btnARTypeSubmit" variant="outline-primary" type="submit">
            {" "}
            {(data.ARType.ARTypeId || 0) === 0 ? "Submit" : "Save Changes"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default forwardRef(AddEditARTypeMaster);
